/*
MP Tentativo checkbox richiedi installazione prima del campo note.
Problema: non mantiene la selezione "flaggato" al cambiare di pagina. Viene ripristinata solo ad eventi js del carrello (es: hover prodotto)
*/
/*
// Configurazione testo traducibile dal pannello Shopify
const checkboxElement = document.getElementById('installation-checkbox');
const CHECKBOX_TEXT = checkboxElement?.dataset.checkboxText || "Chiamatemi per preventivo installazione";
const CHECKBOX_LABEL = checkboxElement?.dataset.checkboxLabel || "Ho bisogno dell'installazione di almeno uno dei prodotti, chiamatemi alla ricezione dell'ordine";

const STORAGE_KEY = 'cart_installation_requested';

// Funzione per gestire il checkbox
function setupInstallationCheckbox() {
  const checkbox = document.getElementById('installation-checkbox');
  const noteField = document.getElementById('CartDrawer-Note');

  if (!checkbox || !noteField) {
    return false;
  }

  // Evita di inizializzare più volte lo stesso checkbox
  if (checkbox.dataset.initialized === 'true') {
    return true;
  }

  // Ripristina lo stato salvato IMMEDIATAMENTE
  const savedState = localStorage.getItem(STORAGE_KEY) === 'true';
  
  // Marca come inizializzato PRIMA di clonare
  checkbox.dataset.initialized = 'true';
  checkbox.checked = savedState;
  
  // Se era selezionato, aggiungi il testo
  if (savedState && !noteField.value.includes(CHECKBOX_TEXT)) {
    noteField.value = noteField.value 
      ? `${noteField.value}\n\n${CHECKBOX_TEXT}` 
      : CHECKBOX_TEXT;
  }

  // Aggiungi listener senza clonare (per evitare di perdere lo stato)
  checkbox.addEventListener('change', function handleCheckboxChange() {
    // Salva lo stato
    localStorage.setItem(STORAGE_KEY, this.checked);
    
    if (this.checked) {
      // Aggiungi il testo se non è già presente
      if (!noteField.value.includes(CHECKBOX_TEXT)) {
        noteField.value = noteField.value 
          ? `${noteField.value}\n\n${CHECKBOX_TEXT}` 
          : CHECKBOX_TEXT;
      }
    } else {
      // Rimuovi il testo
      noteField.value = noteField.value
        .replace(CHECKBOX_TEXT, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    }
  }, { once: false });

  return true;
}

// Funzione che tenta di inizializzare il checkbox con retry
function initWithRetry(maxAttempts = 20, delay = 50) {
  let attempts = 0;
  
  const tryInit = function() {
    attempts++;
    const success = setupInstallationCheckbox();
    
    if (!success && attempts < maxAttempts) {
      setTimeout(tryInit, delay);
    }
  };
  
  tryInit();
}

// Ascolta l'apertura del drawer
document.addEventListener('cart-drawer-open', function() {
  initWithRetry();
});

// Re-applica lo stato quando il carrello viene aggiornato (cambio quantità)
document.addEventListener('cart-update', function(event) {
  const { cartData } = event.detail;
  
  // Pulizia localStorage solo quando il carrello viene completamente svuotato
  if (cartData && cartData.item_count === 0) {
    localStorage.removeItem(STORAGE_KEY);
  }
  
  initWithRetry();
});

// Re-applica lo stato quando un prodotto viene rimosso
document.addEventListener('cart-remove', function(event) {
  const { cartData } = event.detail;
  
  // Pulizia localStorage solo quando il carrello viene completamente svuotato
  if (cartData && cartData.item_count === 0) {
    localStorage.removeItem(STORAGE_KEY);
  }
  
  initWithRetry();
});

// Inizializza al caricamento pagina
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initWithRetry();
  });
} else {
  initWithRetry();
}
  */


/**
 * Script per visualizzare prezzi IVA esclusa + IVA inclusa
 * Fix per problema centesimi e selettori multipli
 * Version: 2.1
 */

(function() {
  'use strict';
  
  const VAT_RATE = 0.22;
  
  /**
   * Formatta un numero come prezzo in formato italiano
   * @param {number} price - Prezzo da formattare
   * @returns {string} - Prezzo formattato (es: "999,00")
   */
  function formatPrice(price) {
    return price.toFixed(2).replace('.', ',');
  }
  
  /**
   * Calcola il prezzo IVA esclusa da un prezzo IVA inclusa
   * @param {number} priceInclVAT - Prezzo con IVA inclusa
   * @returns {number} - Prezzo IVA esclusa
   */
  function calculatePriceExclVAT(priceInclVAT) {
    return priceInclVAT / (1 + VAT_RATE);
  }
  
  /**
   * Estrae il valore numerico da una stringa di prezzo in formato italiano
   * FIX: gestisce correttamente il punto come separatore migliaia e virgola per decimali
   * @param {string} priceText - Testo del prezzo (es: "€1.045,00" o "€999,00")
   * @returns {number|null} - Valore numerico o null se parsing fallisce
   */
  function parsePriceFromText(priceText) {
    if (!priceText) return null;
    
    // Rimuovi simboli valuta, spazi, e caratteri non numerici (tranne punto, virgola)
    let cleanText = priceText.replace(/[€\s]/g, '');
    
    // FORMATO ITALIANO: punto = migliaia, virgola = decimali
    // Es: "1.045,00" -> rimuovi punto -> "1045,00" -> sostituisci virgola con punto -> "1045.00"
    cleanText = cleanText.replace(/\./g, '');  // Rimuovi separatori migliaia
    cleanText = cleanText.replace(',', '.');    // Virgola diventa punto decimale
    
    const price = parseFloat(cleanText);
    
    // Validazione: il prezzo deve essere un numero valido e positivo
    if (isNaN(price) || price <= 0) {
      console.warn('[VAT Script] Parsing fallito per:', priceText);
      return null;
    }
    
    return price;
  }
  
  /**
   * Trasforma un singolo elemento prezzo
   * @param {Element} priceElement - Elemento DOM contenente il prezzo
   */
  function transformPriceElement(priceElement) {
    // Skip se già processato
    if (priceElement.dataset.vatProcessed === 'true') {
      return;
    }
    
    // Estrai il testo originale
    const originalText = priceElement.textContent.trim();
    const priceInclVAT = parsePriceFromText(originalText);
    
    if (!priceInclVAT) {
      console.warn('[VAT Script] Impossibile parsare prezzo:', originalText);
      return;
    }
    
    // Calcola prezzo IVA esclusa
    const priceExclVAT = calculatePriceExclVAT(priceInclVAT);
    
    // Verifica se questo prezzo è barrato (dentro tag <s>)
    const isStriked = priceElement.closest('s') !== null;
    
    // Crea il nuovo markup
    // Se barrato: wrappa i numeri in <s> per strikethrough solo sui prezzi
    const newMarkup = isStriked ? `
      <span class="price-vat-wrapper">
        <span class="price-excl-vat"><s>€${formatPrice(priceExclVAT)}</s> <small>IVA escl.</small></span>
        <span class="price-incl-vat"><s>€${formatPrice(priceInclVAT)}</s> <small>IVA incl.</small></span>
      </span>
    ` : `
      <span class="price-vat-wrapper">
        <span class="price-excl-vat">€${formatPrice(priceExclVAT)} <small>IVA escl.</small></span>
        <span class="price-incl-vat">€${formatPrice(priceInclVAT)} <small>IVA incl.</small></span>
      </span>
    `;
    
    // Sostituisci il contenuto
    priceElement.innerHTML = newMarkup;
    
    // Marca come processato
    priceElement.dataset.vatProcessed = 'true';
    
    console.log('[VAT Script] Processato:', originalText, '→', priceExclVAT.toFixed(2), '(excl) /', priceInclVAT.toFixed(2), '(incl)');
  }
  
  /**
   * Processa tutti i prezzi nella pagina
   * FIX: usa selettori specifici per evitare duplicati
   */
  function processAllPrices() {
    // SELETTORI SPECIFICI per evitare di processare lo stesso prezzo due volte
    
    // 1. Prezzi di vendita (sempre visibili)
    const salePrices = document.querySelectorAll('.price-item--sale:not([data-vat-processed="true"])');
    
    // 2. Prezzi regolari BARRATI (tag <s> che sono price-item--regular)
    // Sia s .price-item--regular che s.price-item--regular
    const regularPricesStriked = document.querySelectorAll('s.price-item--regular:not([data-vat-processed="true"]), s .price-item--regular:not([data-vat-processed="true"])');
    
    // 3. Prezzi regolari NON BARRATI (solo se non c'è sale price)
    // Questi sono i prezzi normali quando il prodotto non è in sconto
    const regularPricesNonStriked = document.querySelectorAll('.price__regular > .price-item--regular:not([data-vat-processed="true"])');
    
    let processedCount = 0;
    
    // Processa prezzi in sconto
    salePrices.forEach(element => {
      transformPriceElement(element);
      processedCount++;
    });
    
    // Processa prezzi regolari barrati
    regularPricesStriked.forEach(element => {
      transformPriceElement(element);
      processedCount++;
    });
    
    // Processa prezzi regolari non barrati
    regularPricesNonStriked.forEach(element => {
      transformPriceElement(element);
      processedCount++;
    });
    
    if (processedCount > 0) {
      console.log(`[VAT Script] Processati ${processedCount} prezzi`);
    }
  }
  
  /**
   * Osserva cambiamenti nel DOM per processare prezzi aggiunti dinamicamente
   */
  function setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;
      
      mutations.forEach((mutation) => {
        // Controlla se sono stati aggiunti nodi che potrebbero contenere prezzi
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList.contains('price') || 
                node.querySelector('.price-item') ||
                node.id === 'CartDrawer') {
              shouldProcess = true;
            }
          }
        });
      });
      
      if (shouldProcess) {
        processAllPrices();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    console.log('[VAT Script] MutationObserver attivo');
  }
  
  /**
   * Inizializza lo script
   */
  function init() {
    console.log('[VAT Script] Inizializzazione...');
    
    // Processa prezzi esistenti
    processAllPrices();
    
    // Setup observer per contenuti dinamici
    setupMutationObserver();
    
    // Ascolta eventi custom di Shopify
    document.addEventListener('shopify:section:load', processAllPrices);
    document.addEventListener('shopify:section:reorder', processAllPrices);
    
    console.log('[VAT Script] Inizializzazione completata');
  }
  
  // Esegui quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();